import {DATE_SIZE} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../../commons/hooks/dates'
import sc from '../../../classes.scss'
import s from './date.scss'
import {DateProps} from '.'

const DATE_WIDTH = 108

export const Date = ({t, customColorClass = '', size, scheduleTbd, event}: DateProps) => {
  const {weekDay, monthDay, month} = useEventDateInformation(event.id)
  const eventDateInfo = scheduleTbd ? t('listDateTbd') : `${weekDay} ${monthDay} ${month}`

  return (
    <div
      className={classNames(s.listHeaderTitle, sc.row, customColorClass || s.color, [s[DATE_SIZE[size]]])}
      style={{minWidth: DATE_WIDTH}}
      data-hook={scheduleTbd ? 'ev-date-tbd' : 'ev-date'}
    >
      <span className={s.srOnly} aria-hidden={scheduleTbd ? true : false}>
        {eventDateInfo}
      </span>
      {scheduleTbd ? (
        <div className={classNames(sc.textNoMargin, s.monthDay)} data-hook="ev-date-tbd-text">
          {t('listDateTbd')}
        </div>
      ) : (
        <>
          <div className={classNames(sc.textNoMargin, s.monthDay)} data-hook="ev-date-month-day" aria-hidden="true">
            {monthDay}
          </div>
          <div className={classNames(sc.textNoMargin, s.weekAndMonth)}>
            <div
              className={s.weekDay}
              style={customColorClass ? null : {opacity: 0.5}}
              data-hook="ev-date-weekday"
              aria-hidden="true"
            >
              {weekDay}
            </div>
            <div className={s.month} data-hook="ev-date-month" aria-hidden="true">
              {month}
            </div>
          </div>
        </>
      )}
    </div>
  )
}
